import DocumentsTable from "features/documentsTable/consumerPortal/documentsTable";

function DocumentsPage() {
  return <DocumentsTable />;
}

export default DocumentsPage;
